import * as _ from 'lodash';
import { DEFAULT_DROPDOWN_ID } from '../../constants';

export const filterPublications = ({
    publications,
    selectedCountry,
    selectedState
}) => {
    if (selectedCountry !== '' && selectedCountry !== DEFAULT_DROPDOWN_ID) {
        publications = publications.filter(pub => pub.countryCode === selectedCountry);
    }
    if (selectedState !== '' && selectedState !== DEFAULT_DROPDOWN_ID) {
        publications = publications.filter(pub => pub.state === selectedState);
    }

    return publications.map(pub => ({ key: pub.id, value: pub.name }));
};

export const modifyCollection = (collection, keyName, selectedKey) => {
    if (selectedKey !== '' && collection !== undefined) {
        const item = collection.find(i => i[keyName] === selectedKey);
        if (item !== undefined) {
            item.selected = true;
        }
    }
    return collection;
};

const buildTree = (node) => {
    const nodeDetail = { title: node.description, subtitle: node.label, expanded: true };
    if (node.childNodes.length > 0) {
        nodeDetail.children = [];
        _.forEach(node.childNodes, (child) => {
            nodeDetail.children.push(buildTree(child));
        });
    }

    if (node.mappedSpineNodes.length > 0) {
        if (nodeDetail.children === undefined) {
            nodeDetail.children = [];
        }
        _.forEach(node.mappedSpineNodes, (spine) => {
            nodeDetail.children.push({ title: spine.code, subtitle: 'Spine Node', className: 'spineNode' });
        });
    }

    return nodeDetail;
};

export const convertToTreeData = (sectionDetail) => {
    const nodes = [];
    if (sectionDetail !== undefined) {
        _.forEach(sectionDetail.nodes, (node) => {
            nodes.push(buildTree(node));
        });
    }

    return { nodes, version: Math.random(), sectionId: sectionDetail.id };
};

export const getCurriculumAlignmentDocuments = ({
    alignmentDocumentName,
    documentName,
    initialValue,
    publicationName,
    sectionName,
    sectionYearGroups
}) => (
    alignmentDocumentName ? {
        alignmentDocumentName,
        documentName,
        publicationName,
        sectionName,
        sectionYearGroups
    } : initialValue
);



// WEBPACK FOOTER //
// ./app/containers/curriculum-list/helpers.js